module.exports = __webpack_public_path__ + "img/multi-office_function.ed34cd1c.png";